import InboxRulesSection from './InboxRulesSection';
import getActionClauseTypeOptions from '../actions/helpers/getActionClauseTypeOptions';
import getConditionalExceptionClauseTypeOptions from '../actions/helpers/getConditionalExceptionClauseTypeOptions';
import resetInboxRuleEdit from '../actions/resetInboxRuleEdit';
import setIgnoreSubsequentRules from '../actions/helpers/setIgnoreSubsequentRules';
import ClauseSectionType from '../actions/types/ClauseSectionType';
import store from '../store/store';
import { observer } from 'mobx-react';
import * as React from 'react';
import { OptionsCheckbox } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import { ControlIcons } from 'owa-control-icons';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import setEditStateShouldRunRuleNow from '../mutators/setEditStateShouldRunRuleNow';
import { isFeatureEnabled } from 'owa-feature-flags';
import canRunCurrentEditRule from '../selectors/canRunCurrentEditRule';

const styles = require('./InboxRulesEdit.scss');
const stopProcessingRulesLearnMoreUrl =
    'https://support.office.com/en-US/client/results?Shownav=true&lcid=1033&ns=OLWAO365B&version=15&omkt=en-US&ver=15&v=15.20.298.0&mode=Desktop&helpid=ms.exch.owab.InboxRulesStopProcessing';

@observer
export default class InboxRulesEdit extends React.Component<{}, {}> {
    componentWillUnmount() {
        resetInboxRuleEdit();
    }

    render() {
        let showExceptions = store.inboxRulesEditState.exceptionClauseIds.length > 0;

        return (
            <div>
                {this.getInboxRulesSection('name')}
                {this.getInboxRulesSection('conditional')}
                {this.getInboxRulesSection('action')}
                {showExceptions && this.getInboxRulesSection('exception')}
                {this.renderIgnoreSubsequentRulesCheckbox()}
            </div>
        );
    }

    private getInboxRulesSection(sectionType: ClauseSectionType) {
        let editState = store.inboxRulesEditState;

        switch (sectionType) {
            case 'name':
                return <InboxRulesSection sectionType={sectionType} numStep={1} />;
            case 'conditional':
                return (
                    <InboxRulesSection
                        sectionType={sectionType}
                        numStep={2}
                        clauseIds={editState.conditionalClauseIds}
                        clauseTypeOptions={getConditionalExceptionClauseTypeOptions()}
                    />
                );
            case 'action':
                return (
                    <InboxRulesSection
                        sectionType={sectionType}
                        numStep={3}
                        clauseIds={editState.actionClauseIds}
                        clauseTypeOptions={getActionClauseTypeOptions()}
                    />
                );
            case 'exception':
                return (
                    <InboxRulesSection
                        sectionType={sectionType}
                        numStep={4}
                        clauseIds={editState.exceptionClauseIds}
                        clauseTypeOptions={getConditionalExceptionClauseTypeOptions()}
                    />
                );
            default:
                throw new Error(
                    'Cannot get inbox rule section component for a section type that does not exist'
                );
        }
    }

    private renderIgnoreSubsequentRulesCheckbox(): JSX.Element {
        return (
            <>
                <div className={styles.ignoreSubsequentRulesCheckbox}>
                    <OptionsCheckbox
                        checked={store.inboxRulesEditState.ignoreSubsequentRules}
                        label={strings.options_inboxRules_stopProcessingRules}
                        onChange={(ev, checked) => setIgnoreSubsequentRules(checked)}
                    />
                    <IconButton
                        iconProps={{
                            iconName: ControlIcons.Info,
                            styles: {
                                root: styles.infoIcon,
                            },
                        }}
                        onClick={() => {
                            const infoWindow = window.open(
                                stopProcessingRulesLearnMoreUrl,
                                '_blank',
                                'height = 500, width=400'
                            );
                            if (infoWindow.focus) {
                                infoWindow.focus();
                            }
                        }}
                    />
                </div>
                {isFeatureEnabled('tri-bulkActionNotification') &&
                    isFeatureEnabled('tri-runRulesNow') &&
                    canRunCurrentEditRule() && (
                        <div className={styles.runRuleNowCheckbox}>
                            <OptionsCheckbox
                                checked={store.inboxRulesEditState.shouldRunRuleNow}
                                label={strings.options_inboxRules_runRuleNow}
                                onChange={(ev, checked) => setEditStateShouldRunRuleNow(checked)}
                            />
                        </div>
                    )}
            </>
        );
    }
}
